// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Ritesh",
  middleName: "",
  lastName: "Patidar",
  message: " Passionate about changing the world with technology. ",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/PatidarRitesh",
    },
    // {
    //   image: "fa-facebook",
    //   url: "",
    // },
    
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/ritesh-patidarr",

   },
  {
    image: "fa-instagram",
    url: "https://www.instagram.com/ritesh__patidar/?next=%2F",
  },
    // {
    //   image: "fa-twitter",
    //   url: "https://www.linkedin.com/in/ritesh-patidarr",
    // },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/Ritesh_image.jpeg"),
  imageSize: 350,
  message:"I'm Ritesh Patidar,",
  resume: "https://drive.google.com/file/d/1MnIt3IF7nnh8q9ejk_9JpSLlhAyDb2MH/view?usp=drive_link",
  // resume: require("../editable-stuff/Ritesh_resume.pdf"),
};

// const about = {
//   show: true,
//   heading: "About Me",
//   imageLink: require("../editable-stuff/Ritesh_image.jpeg"),
//   imageSize: 350,
//   message: `
//     My name is Ritesh Patidar. Currently pursuing my M.Tech in Computer Science at IIT Gandhinagar, I'm passionate about NLP and actively engaged in a project under <a href="https://mayank4490.github.io/">Prof. Mayank Singh</a>. My interests span software development and data science, and I'm excited about contributing to innovative tech solutions. Let's connect and explore the possibilities together!
//   `,
//   resume: "https://drive.google.com/file/d/1MnIt3IF7nnh8q9ejk_9JpSLlhAyDb2MH/view?usp=drive_link",
// };

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Recent Projects",
  gitHubUsername: "PatidarRitesh", //i.e."johnDoe12Gh"
  reposLength: 8,
  specificRepos: [],
};
// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    { 
      img: require("../editable-stuff/Ritesh_image.jpeg"), 
      label: "First slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
    { 
      img: require("../editable-stuff/Ritesh_image.jpeg"), 
      label: "Second slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "Python", value: 95 },
    { name: "C/C++", value: 85 },
    { name: "Java", value: 60 },
    { name: "FastAPI", value: 90 },
    { name: "Flask", value: 75 },
    { name: "Django", value: 65 },
    { name: "PostgreSQL", value: 85 },
    { name: "MySQL", value: 75 },
    { name: "LangChain", value: 85 },
    { name: "LangGraph", value: 75 },
    { name: "LLMs / RAG", value: 85 },
    { name: "Agentic Systems", value: 80 },
    { name: "Vector DBs", value: 75 },
    { name: "NLP", value: 80 },
    { name: "PyTorch", value: 70 },
    { name: "Speech-to-Text / LiveKit", value: 75 },
    { name: "Kafka", value: 75 },
    { name: "Temporal", value: 70 },
    { name: "Server-Sent Events (SSE)", value: 80 },
    { name: "Docker", value: 85 },
    { name: "Kubernetes", value: 65 },
    { name: "AWS (EC2, S3, RDS, SQS, Lambda, ECR)", value: 80 },
    { name: "CI/CD / GitHub Actions", value: 75 },
    { name: "Linux / Nginx", value: 75 },
    { name: "Git & GitHub", value: 85 },
  ],
  softSkills: [
    { name: "Leadership", value: 85 },
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Creativity", value: 85 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I'm looking for full-time Software Engineering or Data Science opportunities! If you know of any positions available, if you have any questions, or if you just want to say hi, please feel free to email me at",
  email: "riteshpatidar2499@gmail.com",
};

const experiences = {
  show: true,
  heading: "Experiences",
  data: [
    {
      role: 'Sr. Associate, Technology (Back End Development)',
      companylogo: require('../assets/img/brahma.png'),
      date: 'Feb 2025 – Present',
    },
    {
      role: 'Backend Engineer',
      companylogo: require('../assets/img/NeuroReef.png'),
      date: 'May 2024 – Jan 2025',
    },
    {
      role: 'NLP Researcher',
      companylogo: require('../assets/img/lingo.png'),
      date: 'Dec 2022 – May 2024',
    },

  ]
}

// Blog SECTION
// const blog = {
//   show: true,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences };